import { formatInTimeZone } from "date-fns-tz";
import { type FC, useMemo } from "react";

import type { PageMetadata } from "@moment/api-collab/api-types";

import { Row } from "../../layout/row/Row";

export const PagePublishedOnDate: FC<{
	pageMetadata: PageMetadata | null;
}> = ({ pageMetadata }) => {
	const date = useMemo(() => {
		if (!pageMetadata?.publishedOn) {
			return;
		}

		return formatInTimeZone(pageMetadata.publishedOn, "UTC", "MMM d, yyyy");
	}, [pageMetadata?.publishedOn]);

	if (!pageMetadata?.publishedOn) {
		return <></>;
	}

	return (
		<div className="rich-text mt-8 -mb-6">
			<Row>
				<div className="text-secondary text-base uppercase border-l-2 -ml-4 pl-4 border-brand">
					{date}
				</div>
			</Row>
		</div>
	);
};
